import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lastAutosaved"]

  static values = {
    label: { type: String, default: "Last autosaved" },
  }

  updateLastAutosaved(event) {
    if (!this.hasLastAutosavedTarget) return

    const autosavedAt = event.detail?.autosavedAt || new Date()
    this.lastAutosavedTarget.innerHTML = `<b>${this.labelValue}:</b> ${this.formatAutosavedAt(autosavedAt)}`
  }

  formatAutosavedAt(value) {
    const date = value instanceof Date ? value : new Date(value)
    const months = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."]
    const hours = date.getHours()
    const displayHour = hours % 12 || 12
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const meridiem = hours >= 12 ? "pm" : "am"

    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()} ${displayHour}:${minutes} ${meridiem}`
  }
}
